import { BadgePassThroughOptions, BadgeProps } from 'primereact/badge';
import { classNames } from 'primereact/utils';

export const PTBadge: BadgePassThroughOptions = {
  root: ({ props }: { props: BadgeProps }) => ({
    className: classNames(
      'rounded-full p-0 text-center inline-block',
      'font-medium',
      {
        'bg-green-10 text-green': props.severity == 'secondary',
        'bg-green text-white ': props.severity == 'success',
        'bg-purple text-white': props.severity == 'info',
        'bg-orange text-white': props.severity == 'warning',
        'bg-red text-white': props.severity == 'danger',
      },
      {
        'text-xs min-w-[0.5rem] h-[0.5rem] leading-[1rem] ': props.size == null,
        'text-lg min-w-[2.25rem] h-[2.25rem] leading-[2.25rem]':
          props.size == 'large',
        'text-2xl min-w-[3rem] h-[3rem] leading-[3rem]': props.size == 'xlarge',
      },
    ),
  }),
};
